module.exports = __webpack_public_path__ + "static/media/underline.2a9f880c.svg";